module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-skus"
  }, [(!_vm.skus) ? _c('loading') : _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.skus), function(sku) {
    return _c('div', {
      staticClass: "col-sm-6 col-md-4",
      class: {
        'col-lg-3': _vm.parent == 'catalog'
      }
    }, [_c('router-link', {
      attrs: {
        "to": _vm.getRouteParams(sku),
        "id": 'sku-' + sku.id
      }
    }, [_c('div', {
      staticClass: "product-catalog-item with-prices"
    }, [_c('div', {
      staticClass: "chevron visible-xs"
    }, [_c('i', {
      staticClass: "fa fa-angle-right fa-3x"
    })]), _vm._v(" "), _c('div', {
      staticClass: "img-container"
    }, [_c('img', {
      staticClass: "img-responsive-center",
      attrs: {
        "src": sku.image,
        "alt": sku.title + ' - Loca.Shop'
      }
    })]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(sku.title))]), _vm._v(" "), _c('p', [(parseInt(sku.quantity_companies) == 1) ? [_vm._v("Em "), _c('b', [_vm._v(_vm._s(sku.unique_company))]), _vm._v(" por:")] : [_vm._v("Em "), _c('b', [_vm._v(_vm._s(sku.quantity_companies) + " locadoras")]), _vm._v(" a partir de:")]], 2), _vm._v(" "), _c('p', {
      staticClass: "prices"
    }, [(sku.price_day > 0) ? [_c('strong', {
      staticClass: "text-success"
    }, [_vm._v(_vm._s(_vm._f("money")(sku.price_day)))]), _vm._v(" "), _c('small', [_vm._v("por dia")]), _c('br')] : _vm._e(), _vm._v(" "), (sku.price_week > 0) ? [_c('strong', {
      staticClass: "text-success"
    }, [_vm._v(_vm._s(_vm._f("money")(sku.price_week)))]), _vm._v(" "), _c('small', [_vm._v("por semana")]), _c('br')] : _vm._e(), _vm._v(" "), (sku.price_biweek > 0) ? [_c('strong', {
      staticClass: "text-success"
    }, [_vm._v(_vm._s(_vm._f("money")(sku.price_biweek)))]), _vm._v(" "), _c('small', [_vm._v("por quinzena")]), _c('br')] : _vm._e(), _vm._v(" "), (sku.price_month > 0) ? [_c('strong', {
      staticClass: "text-success"
    }, [_vm._v(_vm._s(_vm._f("money")(sku.price_month)))]), _vm._v(" "), _c('small', [_vm._v("por mês")])] : _vm._e()], 2)])])], 1)
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1967b695!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListSkus.vue
// module id = 43
// module chunks = 1 5